import React from 'react'

import { ReactComponent as AgendaTitle } from 'public/assets/solstice/images/Agenda.svg'

interface Props {
  className?: string
}
type Schedule = {
  title: string
  subTitle: string
  events: {
    date: string
    name: string
    authorName: string
    moderator?: string
  }[]
}

const schedule: { [key: string]: Schedule } = {
  stage1: {
    title: 'Stage 1',
    subTitle: '(d)Coding Creativity',
    events: [
      {
        date: '12:00 - 12:30 PM',
        name: 'Opening Keynote - Creativity is Free',
        authorName: 'Mayur Hola'
      },
      {
        date: '12:30 – 1:15 PM',
        name: 'Panel Discussion | Future of Design: The Influence of AI and Technology',
        authorName: 'Kavitha Kalyan, Lulu Raghavan'
      },
      {
        date: '2:00 – 2:30 PM',
        name: "Panel Discussion | Digital Design and It's Future for Organisations",
        authorName: 'Richa Khera, Vidisha Debsarkar'
      },
      {
        date: '3:00 – 3:30 PM',
        name: 'Spotlight | Data Driven Creativity',
        authorName: 'Yuzdi N. Badhniwalla'
      },
      {
        date: '4:00 – 4:30 PM',
        name: 'Spotlight | Building for Bharat',
        authorName: 'Kshitiz Anand'
      },
      {
        date: '5:30 – 6:30 PM',
        name: 'Panel Discussion | How Good Design Changes Consumer Perception',
        authorName: 'Rajat Sinha, Surabhi Kanjilal, Swaarup Chatterjjee'
      },
      {
        date: '6:00 – 6:30 IST',
        name: 'Fireside Chat | Different screens - different content',
        authorName: 'Baljit Singh Chaddha'
      },
      {
        date: '7:00 – 7:30 IST',
        name: 'Closing Keynote - Every Company is a Content Company ',
        authorName: 'Rishabh Shekar'
      }
    ]
  },
  stage2: {
    title: 'Stage 2',
    subTitle: 'Design Marketing',
    events: [
      {
        date: '12:30 – 1:00 PM',
        name: 'Panel Discussion | Creating Creative Content in a Non-Creative Setting',
        authorName: "Rohit Malkani, Manish Pandey, Diana D'Souza"
      },
      {
        date: '1:00 – 1:30 PM',
        name: 'Fireside Chat | Talent in Creative Industry',
        authorName: 'Emmanuel Upputuru'
      },
      {
        date: '1:30 – 2:00 PM',
        name: 'Panel Discussion | Building Creative Campaigns for Traditional Organizations',
        authorName: 'Ayaaz Khan, Sameer Mehta'
      },
      {
        date: '2:00 – 2:30 PM',
        name: 'Panel Discussion: The Digital Ignition: Being Creative In A Sensitive Environment',
        authorName: 'Smita Murarka, Sai Ganesh, Hitesh Rajwani'
      },
      {
        date: '2:30 – 3:00 PM',
        name: 'Fireside Chat |  Building a Holistic Social Welfare Brand!',
        authorName: 'Harteerath Singh Ahluwalia'
      },
      {
        date: '3:30 – 4:00 PM',
        name: 'Spotlight | CoCreated: An Inside Look at Collaborative Creativity',
        authorName: 'Tarun Katial'
      },
      {
        date: '5:00 – 5:30 PM',
        name: 'Panel Discussion | The Art of Storytelling',
        authorName: 'Imran Shamsi, Rees Gargi'
      }
    ]
  },
  stage3: {
    title: 'Stage 3',
    subTitle: 'Customise Your Creativity',
    events: [
      {
        date: '1:00 – 1:30 PM',
        name: 'Masterclass | Breaking into the field of UX Design',
        authorName: 'Ansh Mehra'
      },
      {
        date: '1:30 – 2:00 PM',
        name: 'A Masterclass on Becoming an Artist without a Degree',
        authorName: 'Neha Doodles'
      },
      {
        date: '2:30 – 3:00 PM',
        name: 'Panel Discussion | Designing for the Next Billion Users',
        authorName: 'Harmind Singh Arora, Gaurav Mathur'
      },
      {
        date: '3:00 – 3:30 PM',
        name: 'Spotlight | One For The Road | Notes for a creative life',
        authorName: 'Anand Jha'
      },
      {
        date: '3:30 – 4:00 PM',
        name: 'Panel Discussion | Demonstrating Creative Strategies for Different Industries',
        authorName: 'Harshil Karia,  Roshan Abbas, Sahil Vaidya'
      },
      {
        date: '4:00 – 4:30 PM',
        name: 'Spotlight | Web 3.0 Design: The Future or Another Internet Fad?',
        authorName: 'Rahul Bhadoriya'
      },
      {
        date: '5:00 – 5:30 PM',
        name: 'Panel Discussion | Designing for the Metaverse, Web 3.0 and Circular Futures',
        authorName: 'Ayush Wadhwa, Ashay Gangwar'
      },
      {
        date: '6:30 – 7:00 PM',
        name: 'Masterclass | The Process Behind Creating Book Designs',
        authorName: 'Maithili Joshi '
      }
    ]
  }
}

const SolsticeAgenda: React.FC<Props> = ({ className }) => {
  return (
    <div className={className} id="agenda">
      <div className="max-w-lg mx-auto | text-center | pt-10">
        <AgendaTitle />
      </div>
      <div className="grid lg:grid-cols-3 gap-8 | text-left | pt-10">
        <ScheduleList
          highlightColor="hsla(44, 100%, 48%, 1)"
          schedule={schedule.stage1}
        />
        <ScheduleList
          highlightColor="hsla(249, 73%, 20%, 1)"
          schedule={schedule.stage2}
        />
        <ScheduleList
          highlightColor="hsla(148, 75%, 40%, 1)"
          schedule={schedule.stage3}
        />
      </div>
    </div>
  )
}

const ScheduleList = ({
  schedule,
  highlightColor
}: {
  schedule: Schedule
  highlightColor: string
}) => {
  return (
    <div>
      <header className="text-white | py-6">
        <span className="h5">{schedule.title}</span>
        <div
          className="font-bold | h5"
          style={{ fontSize: 24, color: 'hsla(44, 100%, 48%, 1)' }}
        >
          {schedule.subTitle}
        </div>
      </header>
      <div className="space-y-3">
        {schedule.events.map(event => (
          <div
            key={event.authorName}
            className="bg-white | p-4 pl-6 | space-y-2"
            style={{
              boxShadow: `0px 4px 8px rgba(153, 114, 0, 0.05), inset 4px 0px 0px ${highlightColor}`
            }}
          >
            <p className="text-paragraph-4 font-medium text-gray-90">
              {event.date}
            </p>
            <p className="text-paragraph-3 font-medium text-blue-40">
              {event.name}
            </p>
            <p className="text-paragraph-4 font-medium text-gray-90">
              {event.authorName}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SolsticeAgenda
